// extracted by mini-css-extract-plugin
export default {"editorWrapper":"CommerceNoticeEditor_editorWrapper__URaUJ","toolbar":"CommerceNoticeEditor_toolbar__OThM4","editorContent":"CommerceNoticeEditor_editorContent__uAKV4"};